import LogRocket from 'logrocket';

const refactorReqBodyProperty = (request: any, property: string, content = 'sensitive  data.') => {
	if (request.body && request.body.indexOf(property) >= 0) {
		const body = JSON.parse(request.body);

		body[property] = content;
		request.body = JSON.stringify(body);
	}

	return request.body;
};

const propertiesToRefactor = ['password', 'token'];
const SECRET_RESPONSE_PATHS = ['/generate-password'];
const secretResponseIds = new Set<string>();

export const logrocketInit = () => {
	LogRocket.init(import.meta.env.VITE_LOGROCKET_KEY, {
		network: {
			requestSanitizer: (request) => {
				request.headers['Authorization'] = undefined;

				if (request.url.indexOf('socket.io') >= 0) {
					const url = request.url.split('=')[0];

					request.url = url!;
				}

				for (const property of propertiesToRefactor) {
					request.body = refactorReqBodyProperty(request, property);
				}
				if (SECRET_RESPONSE_PATHS.some((path) => request.url.includes(path))) secretResponseIds.add(request.reqId);

				return request;
			},
			responseSanitizer: (response) => {
				response.headers['Authorization'] = undefined;
				if (secretResponseIds.delete(response.reqId)) response.body = undefined;

				return response;
			},
		},
	});
};
